export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "Can you mix 64-bit software with 32-bit hardware?",
    "description": "You cannot mix 64-bit software with 32-bit hardware."
  },
  {
    "id": 2,
    "topic_id": 4,
    "title": "What are the terms used to describe proprietary and nonproprietary programming code?",
    "description": "Closed source/vendor-specific and open source, respectively."
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "What is the area on a mobile phone that contains the icons for apps called?",
    "description": "The launcher or GUI."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "In Windows, a primary mouse click is typically a single click of which mouse button?",
    "description": "Left."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "Which Settings app category is used to configure screensavers, colors, display options, and monitor drivers in Windows 10?",
    "description": "Personalization."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "What online location was created for users to find apps for use with Windows 11?",
    "description": "Microsoft Store."
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "What is the primary function of an operating system (OS)?",
    "description": "To provide a platform for other software to run and to interface with the hardware."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "What is the difference between a 32-bit and a 64-bit operating system?",
    "description": "A 32-bit OS can address up to 4 GB of RAM, while a 64-bit OS can address much more than 4 GB of RAM."
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "What is a shell in the context of an operating system?",
    "description": "A shell is a program that runs on top of the OS and allows the user to issue commands through a set of menus or another interface."
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "What is the purpose of the Recycle Bin in Windows?",
    "description": "To temporarily store deleted files, allowing users to recover them if needed."
  },
  {
    "id": 11,
    "topic_id": 2,
    "title": "What is the name of the BIOS that supports Secure Boot?",
    "description": "Unified Extensible Firmware Interface (UEFI)."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "After upgrading to Windows 11, which folder contains the prior version of Windows?",
    "description": "C:\\Windows.old."
  },
  {
    "id": 13,
    "topic_id": 1,
    "title": "Which Windows 11 networking feature allows for the sharing of files and printers and local user accounts?",
    "description": "workgroup."
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "What is the administrative share print$ used for?",
    "description": "sharing of print drivers."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "Which Linux utility can be used with wildcards to find matches for a regular expression in a text file?",
    "description": "grep."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "If you type pwd at a Linux command line, what will be the result?",
    "description": "The shell will echo back the present working directory."
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "If you type passwd at the command prompt in Linux, what will be the result?",
    "description": "You will be prompted to change your password."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "What Linux command do you use to run one command with elevated privileges?",
    "description": "sudo."
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "What command-line tool can you use in Linux to change the permissions of an existing file?",
    "description": "chmod."
  },
  {
    "id": 20,
    "topic_id": 2,
    "title": "What is the name of film or glass add-ons that are placed over a monitor to prevent the data on the screen from being readable when viewed from the sides?",
    "description": "Privacy filters."
  },
  {
    "id": 21,
    "topic_id": 1,
    "title": "Copying data, such as contacts, photos, and music, between a computer and a mobile device is referred to as what?",
    "description": "Synchronization."
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "Mobile devices use fingerprints and facial recognition for what type of authentication?",
    "description": "Biometric."
  },
  {
    "id": 23,
    "topic_id": 2,
    "title": "Why should you disable guest accounts?",
    "description": "To increase system security."
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What is a valid reason for keeping firmware updated?",
    "description": "To patch security holes that may be found."
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "Which encryption technology requires a trusted platform module (TPM)?",
    "description": "BitLocker."
  },
  {
    "id": 26,
    "topic_id": 2,
    "title": "What technology allows pairing of mobile devices and, on occasion, the ability to transfer files between them?",
    "description": "Bluetooth."
  },
  {
    "id": 27,
    "topic_id": 4,
    "title": "What is extension type used with Python scripts?",
    "description": ".PY."
  },
  {
    "id": 28,
    "topic_id": 4,
    "title": "What is an example of a low-level programming language?",
    "description": "Machine language or Assembly language."
  },
  {
    "id": 29,
    "topic_id": 4,
    "title": "What is the main difference between scripting languages and programming languages?",
    "description": "Scripting languages are interpreted."
  },
  {
    "id": 30,
    "topic_id": 4,
    "title": "What type of value contains a true or false value?",
    "description": "Boolean."
  },
  {
    "id": 31,
    "topic_id": 4,
    "title": "Which character is used to create comments in VBScripts?",
    "description": "The single quote; for example, 'comment."
  },
  {
    "id": 32,
    "topic_id": 4,
    "title": "What is the extension used for a PowerShell script?",
    "description": ".PS1."
  },
  {
    "id": 33,
    "topic_id": 4,
    "title": "Which remote access technology operates on TCP port 3389?",
    "description": "Remote Desktop Protocol (RDP)."
  },
  {
    "id": 34,
    "topic_id": 4,
    "title": "Which extension does a Windows Batch script use?",
    "description": ".CMD or .BAT."
  },
  {
    "id": 35,
    "topic_id": 1,
    "title": "What are the various commands in PowerShell called?",
    "description": "cmdlets."
  },
  {
    "id": 36,
    "topic_id": 4,
    "title": "What is VBScript based on that allows interaction with operating system?",
    "description": "Component Object Model (COM)."
  },
  {
    "id": 37,
    "topic_id": 4,
    "title": "What is the extension for a Bash script?",
    "description": ".SH."
  },
  {
    "id": 38,
    "topic_id": 1,
    "title": "Which utility in Windows 11 allows for remote assistance?",
    "description": "Quick Assist."
  },
  {
    "id": 39,
    "topic_id": 4,
    "title": "Which component inside the computer case poses the biggest risk for electrocution?",
    "description": "The power supply."
  },
  {
    "id": 40,
    "topic_id": 4,
    "title": "What is the name of the safety sheet supplied with all chemicals?",
    "description": "Material Safety Data Sheet (MSDS)."
  },
  {
    "id": 41,
    "topic_id": 4,
    "title": "What are the three common types of screws used in computers?",
    "description": "straight-slot, Phillips, and Torx."
  },
  {
    "id": 42,
    "topic_id": 4,
    "title": "The type of software license used in corporate or university environments for many users is what?",
    "description": "Corporate, campus, site (or enterprise)."
  },
  {
    "id": 43,
    "topic_id": 4,
    "title": "What device uses a one-megohm resistor to bleed charge away slowly from your body?",
    "description": "An antistatic wrist strap."
  },
  {
    "id": 44,
    "topic_id": 4,
    "title": "To whom must accidents at the workplace be immediately reported?",
    "description": "The employer."
  },
  {
    "id": 45,
    "topic_id": 1,
    "title": "In Windows, which command line tool allows you to view all installed hardware, resources and applications?",
    "description": "MSINFO32."
  },
  {
    "id": 46,
    "topic_id": 1,
    "title": "In Windows, which option places the computer into a state in which the session is saved and can be restored but the monitor and hard disks are turned off?",
    "description": "Sleep."
  },
  {
    "id": 47,
    "topic_id": 1,
    "title": "What is the primary purpose of the Resilient File System (ReFS)?",
    "description": "To maximize data availability, scale efficiently to large data sets, and provide data integrity with resiliency to corruption."
  },
  {
    "id": 48,
    "topic_id": 1,
    "title": "What are the three main event logs in Event Viewer?",
    "description": "Application, Security, and System."
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "What does the Task Manager's Performance tab display?",
    "description": "CPU usage percentage, CPU usage history, number of processes, and physical memory usage."
  },
  {
    "id": 50,
    "topic_id": 4,
    "title": "What is the function of the Disk Management (diskmgmt.msc) snap-in?",
    "description": "To view disk information, partition volumes, format filesystems, and mount volumes to drive letters."
  },
  {
    "id": 51,
    "topic_id": 1,
    "title": "What is the purpose of the Microsoft Management Console (MMC)?",
    "description": "To run administrative and configuration tools in a unified interface."
  },
  {
    "id": 52,
    "topic_id": 1,
    "title": "What does the System Configuration (msconfig.exe) tool allow you to do?",
    "description": "Configure how Windows starts up and launch additional tools."
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "Flash Cards 2 <br>What is the minimum amount of free hard drive space recommended for installing a Windows 11, 64-bit version?",
    "description": "64 GB."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "Where do files go when they are deleted?",
    "description": "Recycle Bin."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "Which Windows feature allows for automatic patching of the operating system?",
    "description": "Windows Update."
  },
  {
    "id": 56,
    "topic_id": 1,
    "title": "Which life cycle term describes the currently supported operating system for patches, updates, and additional feature adds?",
    "description": "Mainstream support."
  },
  {
    "id": 57,
    "topic_id": 1,
    "title": "What is the minimum required amount of RAM to install Windows 11 64-bit?",
    "description": "4 GB."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "Which Microsoft feature allows for automatic VPN connectivity that is location based?",
    "description": "DirectAccess."
  },
  {
    "id": 59,
    "topic_id": 1,
    "title": "What type of operating system is optimized for background processes?",
    "description": "Servers."
  },
  {
    "id": 60,
    "topic_id": 1,
    "title": "What is the name of the Apple OS used on laptops and PCs?",
    "description": "macOS."
  },
  {
    "id": 61,
    "topic_id": 1,
    "title": "Which architecture is primarily used for mobile tables and phones?",
    "description": "ARM."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "What is the minimum amount of RAM required for a 64-bit installation of Windows 10?",
    "description": "2 GB."
  },
  {
    "id": 63,
    "topic_id": 1,
    "title": "What is the primary benefit of using cloud-based productivity tools?",
    "description": "They allow access to files from any device with an Internet connection."
  },
  {
    "id": 64,
    "topic_id": 1,
    "title": "What is the function of Microsoft OneDrive?",
    "description": "To provide cloud storage and backup capabilities, ensuring that files are accessible from any device."
  },
  {
    "id": 65,
    "topic_id": 1,
    "title": "How many days do you have after an upgrade to roll back to the prior operating system?",
    "description": "10 days."
  },
  {
    "id": 66,
    "topic_id": 1,
    "title": "Which command allows you to map the drive of V to the UNC of \\\\server\\files?",
    "description": "NET USE V: \\\\server\\files."
  },
  {
    "id": 67,
    "topic_id": 1,
    "title": "What is the minimum speed processor is required to install Windows 11?",
    "description": "1 GHz or faster."
  },
  {
    "id": 68,
    "topic_id": 4,
    "title": "During the setup of Windows 11, what are the license terms called that you must accept?",
    "description": "End User License Agreement (EULA)."
  },
  {
    "id": 69,
    "topic_id": 1,
    "title": "You want to upgrade from Windows 11 Home to Windows 11 Pro; what is required?",
    "description": "A 25-digit product key for Windows 11 Pro."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "Which command-line tool can be used to collect information about hardware before installing Windows 11?",
    "description": "MSINFO32.EXE."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "Which partition is the Boot Configuration Data stored in for Windows 11?",
    "description": "EFI System Partition (ESP)."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "Which Windows Update branch for Windows 11 allows for security updates, but no new features?",
    "description": "Long-Term Servicing Channel."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "How much RAM is required for a 64-bit installation of Windows 11 Pro?",
    "description": "4 GB of RAM."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "Which networking model provides centralized user login?",
    "description": "Domain."
  },
  {
    "id": 75,
    "topic_id": 2,
    "title": "Which authentication method allows applications to automatically log a user in?",
    "description": "Single Sign-on (SSO)."
  },
  {
    "id": 76,
    "topic_id": 2,
    "title": "What is the purpose of the BitLocker feature in Windows?",
    "description": "To provide drive encryption to protect files, including those needed for startup and login."
  },
  {
    "id": 77,
    "topic_id": 1,
    "title": "What is the role of drivers in an operating system?",
    "description": "Drivers are specific software written to instruct the OS on how to access a piece of hardware."
  },
  {
    "id": 78,
    "topic_id": 1,
    "title": "The Linux command chmod a+r filename will assign which permissions?",
    "description": "read permissions."
  },
  {
    "id": 79,
    "topic_id": 1,
    "title": "Which macOS feature allows you to view all running applications?",
    "description": "Mission Control."
  },
  {
    "id": 80,
    "topic_id": 1,
    "title": "What is the search feature within macOS?",
    "description": "Spotlight."
  },
  {
    "id": 81,
    "topic_id": 1,
    "title": "A file on a Linux workstation has the permissions of rw-r-x--x; what are the permissions the user is assigned?",
    "description": "read / write."
  },
  {
    "id": 23,
    "topic_id": 2,
    "title": "Why should you disable guest accounts?",
    "description": "To increase system security."
  },
  {
    "id": 82,
    "topic_id": 1,
    "title": "Which two protocols does Active Directory use for lookup of objects and authentication of user and computers?",
    "description": "Lightweight Directory Access Protocol (LDAP) and Kerberos."
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What is a valid reason for keeping firmware updated?",
    "description": "To patch security holes that may be found."
  },
  {
    "id": 83,
    "topic_id": 2,
    "title": "Which authentication method uses your fingerprint to authenticate you?",
    "description": "Biometrics."
  },
  {
    "id": 84,
    "topic_id": 2,
    "title": "What type of server examines user credentials and grants them access to network resources?",
    "description": "Authentication."
  },
  {
    "id": 85,
    "topic_id": 2,
    "title": "What can be implemented to prevent tailgating?",
    "description": "Access control vestibule."
  },
  {
    "id": 86,
    "topic_id": 1,
    "title": "What are two locations to which you can sync an iPhone?",
    "description": "The desktop (iTunes) or iCloud."
  },
  {
    "id": 87,
    "topic_id": 2,
    "title": "Which encryption technology allow for the transport of file via encrypted removable drive?",
    "description": "BitLocker To Go."
  },
  {
    "id": 88,
    "topic_id": 4,
    "title": "What type of value can contain only positive and negative whole numbers?",
    "description": "Integer."
  },
  {
    "id": 89,
    "topic_id": 4,
    "title": "Which remote access technology provides a text console that is encrypted and authenticated?",
    "description": "Secure Shell (SSH)."
  },
  {
    "id": 90,
    "topic_id": 4,
    "title": "What is an example of branch logic for a script?",
    "description": "An if statement."
  },
  {
    "id": 91,
    "topic_id": 4,
    "title": "Which extension is used with JavaScript?",
    "description": ".JS."
  },
  {
    "id": 92,
    "topic_id": 1,
    "title": "Which command will allow you to access the Windows command interpreter?",
    "description": "CMD.EXE."
  },
  {
    "id": 93,
    "topic_id": 4,
    "title": "What is the directive that tells the operating system which interpreter to use?",
    "description": "The hashbang #!"
  },
  {
    "id": 94,
    "topic_id": 4,
    "title": "Where is JavaScript primarily used?",
    "description": "Web browsers."
  },
  {
    "id": 95,
    "topic_id": 4,
    "title": "Which remote technology operates with TCP port 22?",
    "description": "Secure Shell (SSH)."
  },
  {
    "id": 96,
    "topic_id": 4,
    "title": "What protocol does the Remote Desktop Connection client use for making remote connections?",
    "description": "Remote Desktop Protocol (RDP)."
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "What statement is used for looping in scripts that has a defined start, end, and step?",
    "description": "A for loop."
  },
  {
    "id": 98,
    "topic_id": 1,
    "title": "Which environment variable is inherited by each user that logs into the operating system?",
    "description": "System variable."
  },
  {
    "id": 99,
    "topic_id": 4,
    "title": "What is the extension used with VBScripts?",
    "description": ".VBS."
  },
  {
    "id": 100,
    "topic_id": 4,
    "title": "What is the most likely type of injury from attempting to fix a laser printer?",
    "description": "Burns."
  },
  {
    "id": 101,
    "topic_id": 4,
    "title": "Electrical contacts should be cleaned with what?",
    "description": "Isopropyl alcohol."
  },
  {
    "id": 102,
    "topic_id": 4,
    "title": "What is the organization responsible for ensuring safe work environments in the U.S. private sector?",
    "description": "The Occupational Safety and Health Administration (OSHA)."
  },
  {
    "id": 103,
    "topic_id": 4,
    "title": "Computer parts can be carried in what to reduce the chance of electrical damage?",
    "description": "Antistatic bags."
  },
  {
    "id": 104,
    "topic_id": 4,
    "title": "Providing properly maintained tools and equipment is the responsibility of whom in a safe work environment?",
    "description": "The employer."
  },
  {
    "id": 105,
    "topic_id": 4,
    "title": "What type of software license would an individual user purchase for their own use?",
    "description": "Personal."
  },
  {
    "id": 106,
    "topic_id": 4,
    "title": "Software that is purchased and requires a license to run is called what?",
    "description": "Commercial."
  },
  {
    "id": 107,
    "topic_id": 4,
    "title": "What are rules imposed on your organization by an outside agency, like a certifying board or a government entity, and they\u2019re usually totally rigid and immutable called?",
    "description": "Regulations."
  },
  {
    "id": 108,
    "topic_id": 1,
    "title": "Which Windows system utility can be used to edit the Registry?",
    "description": "REGEDIT."
  },
  {
    "id": 109,
    "topic_id": 1,
    "title": "Which Windows system utility can be used to make files on the hard drive contiguous?",
    "description": "Disk Defragmenter."
  },
  {
    "id": 110,
    "topic_id": 1,
    "title": "From which Control Panel applet can you choose to hide filename extensions on files when viewing them?",
    "description": "File Explorer Options."
  },
  {
    "id": 111,
    "topic_id": 1,
    "title": "From which Control Panel applet can you remove a username and password that is automatically filled in, when you visit a web page?",
    "description": "Credential Manager."
  },
  {
    "id": 112,
    "topic_id": 1,
    "title": "Which Control Panel applet allows you to add features to the operating system?",
    "description": "Programs and Features."
  },
  {
    "id": 113,
    "topic_id": 1,
    "title": "What is the function of the Group Policy Editor (gpedit.msc)?",
    "description": "To edit the local Group Policy for the operating system."
  },
  {
    "id": 114,
    "topic_id": 1,
    "title": "What is the purpose of the Resource Monitor (resmon.exe)?",
    "description": "To identify resource utilization of CPU, disk, network, and memory."
  },
  {
    "id": 115,
    "topic_id": 1,
    "title": "What does the File Explorer Options applet allow you to do?",
    "description": "Change the default opening pane for File Explorer and control how folders open."
  },
  {
    "id": 116,
    "topic_id": 1,
    "title": "What is the function of the Local Users and Groups (lusrmgr.msc) MMC snap-in?",
    "description": "To create and manage local user and group accounts."
  },
  {
    "id": 117,
    "topic_id": 1,
    "title": "What does the Performance Monitor (perfmon.msc) display?",
    "description": "Performance counters and collects counter information for troubleshooting."
  },
  {
    "id": 118,
    "topic_id": 1,
    "title": "What is the purpose of the Disk Cleanup (cleanmgr.exe) tool?",
    "description": "To clean up operating system files to free up space without affecting data files."
  },
  {
    "id": 119,
    "topic_id": 1,
    "title": "What does the System Information (msinfo32.exe) tool display?",
    "description": "A thorough list of settings on the machine, including hardware and software information."
  },
  {
    "id": 120,
    "topic_id": 1,
    "title": "What is the function of the Device Manager (devmgmt.msc)?",
    "description": "To manage hardware devices, update drivers, and troubleshoot hardware issues."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Know the RAM limitations between operating system architectures.",
    "description": "32-bit operating systems have a RAM limitation of 4 GB, whereas 64-bit operating systems can address over 4 GB of RAM."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Understand an operating system's life cycle.",
    "description": "When development is started on an operating system, it is considered alpha or beta code. Release candidates precede the release to market (RTM) of an operating system. The end of mainstream support generally means only security updates will continue to be supported during the extended support period."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Know the various operating system types and the common operating systems.",
    "description": "The four basic types of operating systems are server, workstation, mobile, and cloud-based. Windows, macOS, and Linux can be used as server, workstation, and mobile operating systems, whereas Google Chrome is primarily a cloud-based operating system."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Know the various editions of Windows 10/11 and their limitations.",
    "description": "The four most common Windows 10/11 editions are Windows 10/11 Home, Pro, Pro for Workstations, and Enterprise. Windows 10/11 Home does not allow joining of domains and has many premium features. Windows 10 Pro is the most flexible edition because it allows for domain joining. Windows 10/11 Pro for Workstations allows for up to 4 CPUs and 6 TB of RAM. Windows 10/11 Enterprise is a volume licensed edition of Windows 10/11 that offers premium features."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Know the various requirements for applications.",
    "description": "The system requirements for an application can be architecture, such as 32-bit versus 64-bit, dedicated graphics cards versus integrated, VRAM and RAM requirements, CPU requirements, the use of external licensing dongles or hardware tokens, storage requirements, and application compatibility."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Know the various cloud applications you will commonly support.",
    "description": "You should be familiar with Exchange Online and Outlook terminology and basic setup. You should also know what each of the Microsoft 365 applications are used for, such as Word, Excel, PowerPoint, and Teams, as well as their Google counterparts."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Understand how to manage files in Windows.",
    "description": "Nearly all file management\u2014including moving, copying, renaming, and deleting files and changing file attributes\u2014is accomplished through Windows File Explorer."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Know where files are located.",
    "description": "The various versions of Windows that you need to know for this exam store files in multiple locations. You should be able to identify the location of those files mentioned in this chapter and be able to identify items such as where the Recycle Bin files are on each Windows operating system."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Know the various filesystems and the differences between them.",
    "description": "The most commonly used filesystem on Windows hard drives is NTFS. FAT32 is older and perhaps a bit quicker for smaller hard drives and USB thumb drives, but NTFS adds a plethora of important features, including security and auditing. exFAT is a filesystem Microsoft adopted to address large filesystems that FAT32 had problems addressing. The Extended filesystem (XFS) is a high-performance 64-bit journaling file system designed to handle large files and high-throughput environments and used with Linux. The Resilient File System (ReFS) is a Windows filesystem designed to maximize data availability, scalability, and integrity. Additionally, you should know that the ext3, ext4, and APFS filesystems are not compatible with Windows without third-party software."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Understand the various partitioning for Windows installs.",
    "description": "The GUID Partition Table (GPT) is a modern specification used with UEFI BIOS, allowing for larger partitions and supporting up to 128 primary partitions. The Master Boot Record (MBR) is the traditional BIOS partition table, allowing for a maximum of four primary partitions or three primary partitions and one extended partition. Formatting a drive involves creating a file allocation table and configuring the root directory, with NTFS being the most commonly used filesystem."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Know which Windows Control Panel utility to use for a given scenario.",
    "description": "A number of Control Panel applets allow you to change Windows' functionality. With the introduction of Windows 10, some of the functionality is split between the Settings app and the classic Control Panel applets; this is carried forward with Windows 11. You should be proficient with both for a given scenario in which changes to the operating system need to be made."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Know which Windows Settings section is used for a given scenario.",
    "description": "The Settings app is slowly replacing Control Panel as the main method of configuring Windows. You should know the major categories of the Settings app and the various settings each of them contains."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Know the main administrative tools.",
    "description": "You should know the primary graphical tools for troubleshooting Windows and configuring the operating system. These include the disk management tools, Windows Tools, Device Manager, Task Manager, System Information, System Restore, Task Scheduler, as well as all other tools covered in this chapter. Know the various disk management concepts."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Know the concepts related to disk management.",
    "description": "You should know the various concepts related to disk management to initialize and mount a drive to assign a drive letter; the concepts of extending, splitting, and shrinking partitions (volumes); fault tolerance arrays; and Storage Spaces. GPT should be used with UEFI/BIOS, addressing 2 TB and larger drives, or if more than 26 logical volumes are required."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Know the Windows installation process and options.",
    "description": "You should know the various options when installing Windows 11, including the various partitions created and the differences between BIOS and UEFI firmware. You should also be familiar with the Windows 11 installation process."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Know which types of installations are possible with Windows.",
    "description": "You should know which operating systems can be upgraded to Windows 11 and which require a clean installation."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Understand upgrading to Windows.",
    "description": "You should know that a custom installation either wipes the old system or replaces the existing system, putting the old files into WINDOWS.OLD. Applications then have to be reinstalled, and user data has to be migrated from the old system using tools such as USMT. An upgrade preserves the existing applications and the user data, moving them into the new operating system."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Understand what each of the command-line utilities does.",
    "description": "Many utilities allow you to perform various functions at the command line. These include cd, dir, ipconfig, ping, netstat, nslookup, net use, tracert, pathping, chkdsk, format, diskpart, md, rmdir, robocopy, hostname, net user, winver, whoami, [command name] /?, gpupdate, gpresult, and sfc. The cmd command opens a command prompt, where you can type the rest of the commands. If you're not sure how to use a particular utility, using the /? switch at the end of the command will provide information about how to use it."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Understand networking in Windows.",
    "description": "You should understand the different networking models in which a Windows operating system can participate: workgroups, domains, and Microsoft Entra ID. You should also understand the basic user authentication methods used with each of these networking models, as well as common methods for accessing networking resources."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Know the various ways to establish a connection.",
    "description": "You should know how to connect and diagnose wired and wireless connections to a network. In addition, you should understand how a WWAN is configured and how VPN networks are used and configured."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Know the various ways to access resources.",
    "description": "You should know how to connect to network shares and printer shares using the UNC path of the resource. In addition, you should know the other types of resources, such as administrative shares and other hardware-based resources that you may encounter."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Know the basic elements of client configuration.",
    "description": "You should be familiar with the Internet Protocol (IP) addressing scheme, Domain Name System (DNS) settings, subnet mask, gateway, and static vs. dynamic IP addressing."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Know how applications are managed with common features and tools in macOS.",
    "description": "Know that applications can be installed via the App Store or downloadable applications. Know the various file types an application installation can be downloaded on. Know how applications are installed by dragging the application to the Applications folder, and be able to describe the uninstallation process of dragging the application to the Trash."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Be able to identify best practices.",
    "description": "Best practices help keep systems and data usable. Among the best practices to follow, it is important to schedule backups, schedule disk maintenance, keep systems up to date, and make sure that antivirus/antimalware definition files are current."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Know the available System settings.",
    "description": "You should be familiar with the various System settings. Know what each setting offers in the form of configuration for macOS."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Know how to use key macOS tools and features.",
    "description": "A number of tools and features are included with macOS that make it an attractive operating system to use. Among them are Mission Control, Keychain, Spotlight, iCloud, Gestures, the Finder, Dock, Disk Utility, File Vault, Terminal, and Force Quit."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Know the basic Linux commands.",
    "description": "Every version and distribution of Linux allows you to get to the command line in one way or another and interact with the shell. From there, you can give commands to navigate around (cd, pwd), to create and change file values (chmod, chown), to run commands (su, sudo), and to do many other tasks."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Know the common configuration files.",
    "description": "The common configuration files you should know for the exam are /etc/passwd, /etc/shadow, /etc/hosts, /etc/fstab, and /etc/resolv.conf. Review the chapter for the various applications of each file."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Understand the various components of Linux.",
    "description": "The various components of Linux that you should understand for the 220-1202 exam are the bootloader, kernel, and systemd. These components are all part of the boot process. The Linux boot process involves initializing the EFI firmware, loading the GRUB bootloader, and then loading and initializing the Linux kernel, which starts the systemd system."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Know the various security measures and their purpose.",
    "description": "There are several different physical security measures that can be applied to the public and your staff. In addition, there are several different logical security measures, such as access control lists (ACLs), multifactor authentication (MFA), and several others discussed in this chapter. Be familiar with their practical application."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Know the various physical security devices.",
    "description": "You should be familiar with the various physical security devices, such as the use of an access control vestibule, badge readers, video surveillance, alarm systems, motion sensors, door locks, equipment locks, guards, bollards, and fences. In addition, you should be able to describe security devices as they relate to staff, such as the use of key fobs, smartcards, keys, biometrics, lighting, and magnetometers."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Know the various logical security methods.",
    "description": "You should be familiar with logical methods of security, such as the implementation and use of access control lists (ACLs), implementing principle of least privilege, and multifactor authentication (MFA), including email, hard tokens, soft tokens, Short Message Service (SMS), voice calls, and authenticator applications as factors of authentication."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Be able to describe why antivirus/antimalware software is needed.",
    "description": "Antivirus/antimalware software looks at a virus and takes action to neutralize it based on a virus definition database. Virus definition database files are regularly made available on vendor sites."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Understand the need for user education.",
    "description": "Users are the first line of defense against most threats, whether physical or digital. They should be trained on the importance of security and how to help enforce it."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Know the types of malware and mitigation.",
    "description": "You should be familiar with the various types of malware commonly found, such as Trojan, rootkit, virus, spyware, ransomware, keylogger, boot sector virus, and cryptominers. In addition, you should be familiar with the various ways to mitigate malware with the use of the recovery console, antivirus, anti-malware, software firewalls, antiphishing training, user education, and OS reinstallation."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Know the various best practices for security.",
    "description": "You should know the best security practices, such as implementing data-at-rest encryption, password complexity, and password expiration, as well as protecting BIOS or UEFI with passwords. In addition, you should know the various end-user best practices, such as using screen saver locks, logging off when a computer or application is not in use, and implementing security and protection of critical hardware as well as security of personally identifiable information (PII) and passwords."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Know how to compare and contrast social engineering, threats, and vulnerabilities.",
    "description": "Social engineering variants include shoulder surfing (watching someone work) and phishing (tricking someone into believing they are communicating with a party other than the one with whom they are communicating). Variations on phishing include vishing, shoulder surfing, whaling, tailgating, impersonation, dumpster diving, and evil twin."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Know the various threats to a network.",
    "description": "You should be familiar with the various threats to a network, such as distributed denial-of-service (DDoS), denial-of-service (DoS), zero-day attack, spoofing, on-path attacks, brute-force password attacks, dictionary password attacks, insider threats, Structured Query Language (SQL) injection, cross-site scripting (XSS), Business email compromise (BEC), and supply chain/pipeline attack."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Understand the need for good passwords.",
    "description": "Passwords are the first line of defense for protecting an account. A password should be required for every account, and strong passwords should be enforced. Users need to understand the basics of password security and work to keep their accounts protected by following company policies regarding passwords."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Understand the difference between standard and low-level formatting.",
    "description": "Standard formatting uses operating system tools and marks the drive as available for holding data without truly removing what was on the drive (thus, the data can be recovered). A low-level format is operating system\u2013independent and destroys any data that was on the drive."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Understand how to implement appropriate data destruction and disposal methods.",
    "description": "A hard drive can be destroyed by tossing it into a shredder designed for such a purpose, or it can be destroyed with an electromagnet in a process known as degaussing. You can also disassemble the drive and destroy the platters with a drill or other tool that renders the data irretrievable. Third party vendors can also be used and they will supply certification of destruction/recycling. Proper disposal is required by regulatory and environmental requirements."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Understand Windows operating system security concepts.",
    "description": "You should be able to compare and contrast Microsoft Windows operating system security settings. This should include knowing the various accounts that are created by default and why you need to disable or rename these accounts. You should also have an in-depth understanding of NTFS permissions and share permissions, and their interaction, to form the effective permissions the user has when accessing a share remotely. In addition, you should have a good understanding of authentication and the options to encrypt both the operating system and removable drives."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Know how to compare wireless security protocols and authentication methods.",
    "description": "Wireless networks can be encrypted through WEP, WPA, WPA2, and WPA3 technologies. Wireless controllers use service-set identifiers (SSIDs)\u201432-character, case-sensitive strings\u2014that must be configured in the network cards to allow communications. However, using ID string configurations doesn\u2019t necessarily prevent wireless networks from being monitored, and there are vulnerabilities specific to wireless devices."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Understand the basics of antenna placement and radio power levels.",
    "description": "Antenna placement can be crucial in allowing clients to reach an access point. Place access points near the center of the area to be served and high enough to get around most obstacles. Know that power level controls allow you to reduce the amount of output provided."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "Know how to configure security on SOHO wireless and wired networks in various scenarios.",
    "description": "Disable all unneeded protocols/ports. If you don\u2019t need them, remove them or prevent them from loading. Ports not in use present an open door for an attacker to enter. MAC filtering allows you to limit access to a network to MAC addresses that are known and filter out (deny access to) those that are not."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "Understand mobile device security concepts.",
    "description": "You should understand how screen locks operate. Explain why we need remote wipe in the event of a device missing or lost. Understand the risks of viruses and malware on mobile devices, as well as measures that can be taken to mitigate these risks. In addition, you should have a good understanding of the importance of full-device encryption, authentication applications, firewalls, and policies for mobile devices."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "Know the common symptoms and solutions for operating system problems.",
    "description": "Be able to identify the five critical systems of CPU, RAM, network, disk, and graphics that interact with an operating system. Know the various symptoms that will lead to operating system problems. Also, be able to identify solutions to operating system problems."
  },
  {
    "id": 168,
    "topic_id": 200,
    "title": "Understand the various security issues related to operating systems.",
    "description": "Be able to identify common security issues that you will see affecting operating systems. You should also understand the impact of these security issues on both the operating system and the organization, as well as common ways to mitigate and solve these security issues."
  },
  {
    "id": 169,
    "topic_id": 200,
    "title": "Know the process for removing malware.",
    "description": "Know the seven steps to remove malware. Be able to identify how to perform these seven steps during the malware-removal process. You should be familiar with the various tools used to identify and remove malware."
  },
  {
    "id": 170,
    "topic_id": 200,
    "title": "Know how to troubleshoot mobile OS and application issues.",
    "description": "Be able to identify the common symptoms of application-based issues for mobile devices. Know how to solve mobile issues for applications on both Android and Apple devices."
  },
  {
    "id": 171,
    "topic_id": 200,
    "title": "Understand mobile device security issues.",
    "description": "You should have a good understanding of the various mobile device security symptoms, problems, and solutions. Be able to articulate how these issues pose a risk to the organization, as well as how these issues can be mitigated and solved."
  },
  {
    "id": 172,
    "topic_id": 200,
    "title": "Understand the basics of scripting.",
    "description": "You should understand that a programming language is compiled and a scripting language is interpreted. You should also understand the various elements of a script, such as the comment, interaction of environment variables, branch logic, and loops."
  },
  {
    "id": 173,
    "topic_id": 200,
    "title": "Know the various scripting languages.",
    "description": "You should know the advantages and disadvantages of each scripting language and the use cases for scripting, as well as other security and system considerations. In addition, you should know which operating systems each of the various scripting languages operates on. Be familiar with the various script file types that correspond to each scripting language."
  },
  {
    "id": 174,
    "topic_id": 200,
    "title": "Know the various scripting file extensions.",
    "description": "The .bat and .cmd extensions are associated with Windows Batch scripts. The .ps1 is associated with PowerShell scripts. The .vbs extension is associated with VBScript scripts. The .sh extension is associated with Bash shell scripts. The .js extension is associated with JavaScript scripts. The .py extension is associated with Python scripts."
  },
  {
    "id": 175,
    "topic_id": 200,
    "title": "Know the various uses for scripts and their considerations.",
    "description": "The various uses for implementing scripts are basic automation, restarting machines, mapping and remapping network drives, installation of applications, automated backups, gathering of information/data, and initiating updates. The considerations are unintentionally introducing malware, inadvertently changing system settings, and browser or system crashes due to mishandling of resources."
  },
  {
    "id": 176,
    "topic_id": 200,
    "title": "Know the various remote access technologies.",
    "description": "You should know that RDP is a Microsoft protocol used for remote access. Virtual Network Computing (VNC) is an open standard similar to Microsoft RDP. SSH is an encrypted, secure console protocol. Remote Monitoring and Management (RMM) is a Microsoft protocol for remote administration. Simple Protocol for Independent Computing Environments (SPICE) is an open source protocol used for VDI. In addition, there are third-party screen-sharing and desktop management tools that function similarly and include file-sharing capabilities, as well as videoconferencing software."
  },
  {
    "id": 177,
    "topic_id": 200,
    "title": "Know the various components of artificial intelligence.",
    "description": "You should know the various components of AI and understand the training of AI, neural networks, large language models (LLMs), natural language processing, and foundation models."
  },
  {
    "id": 178,
    "topic_id": 200,
    "title": "Understand the limitations and considerations for artificial intelligence.",
    "description": "You should understand how biases can flaw the results of AI, as well as what you can do to mitigate the risks of bias. You should also understand how and why AI hallucinations occur and what you can do to prevent propagating wrong information. In addition, you should understand the considerations of policy, appropriate use, and plagiarism with AI."
  },
  {
    "id": 179,
    "topic_id": 200,
    "title": "Know which computer components are particularly dangerous to technicians.",
    "description": "The most dangerous components are the power supply and the monitor. Both are capable of storing lethal charges of electricity, even when unplugged. You also need to be aware of parts that get incredibly hot, such as the processor, which can cause severe burns if touched."
  },
  {
    "id": 180,
    "topic_id": 200,
    "title": "Understand where to find safety information regarding chemicals.",
    "description": "You can find this information in a material safety data sheet (MSDS). An MSDS might not have come with your purchase, but most suppliers will gladly supply one."
  },
  {
    "id": 181,
    "topic_id": 200,
    "title": "Know which tool to use for which job.",
    "description": "The majority of computer repair jobs can be handled with nothing more than a Phillips-head screwdriver. However, you might need cutters, extra light, or a mirror for some jobs. Avoid using magnetic-tipped tools."
  },
  {
    "id": 182,
    "topic_id": 200,
    "title": "Understand methods to help prevent ESD.",
    "description": "One of the biggest and most common dangers of electronic components is electrostatic discharge (ESD). You can employ several methods to help avoid ESD-related problems, such as grounding yourself; using an antistatic wrist strap, bag, or mat; and controlling the humidity levels."
  },
  {
    "id": 183,
    "topic_id": 200,
    "title": "Know the proper disposal procedures for used computer parts, batteries, and chemical solvents.",
    "description": "The specific disposal procedure depends on the item. However, the safe answer is always to recycle the component, not to throw it in the trash."
  },
  {
    "id": 184,
    "topic_id": 200,
    "title": "Know the differences between license types.",
    "description": "Open source applications don't require a purchased license, whereas commercial applications do require a purchased license. Some licenses are personal licenses, meaning the applications are for use by one person on one computer, whereas others are enterprise licenses, meaning the applications can be used on multiple computers at the same time."
  },
  {
    "id": 185,
    "topic_id": 200,
    "title": "Understand how to handle prohibited content or activity.",
    "description": "Always have policies and procedures in place to deal with prohibited content or activity. When an incident happens, follow the procedures, report through proper channels, preserve the data or device using the order or volatility, and follow the chain of custody."
  },
  {
    "id": 186,
    "topic_id": 200,
    "title": "Know the various types of sensitive information.",
    "description": "You should know that personal identifiable information (PII) is any information used to identify an individual. The Payment Card Industry Data Security Standard (PCI DSS) is a standard of policies and procedures used by the payment industry. General Data Protection Regulation (GDPR) is a European Union (EU) law governing how EU citizen data is used. Protected health information (PHI) is any information used to describe a patient or a patient's ailment."
  },
  {
    "id": 187,
    "topic_id": 200,
    "title": "Know the common business agreements.",
    "description": "These agreements include nondisclosure agreements (NDA), mutual nondisclosure agreements (MNDA), and acceptable use policy (AUP). You should understand how they are used to protect organizations and individuals."
  },
  {
    "id": 188,
    "topic_id": 200,
    "title": "Understand the elements of a ticketing system.",
    "description": "You should have a clear understanding of the importance of clear communications in the support process, as well as the important elements in a ticket, such as user information, device information, category of problem, severity of the problem, and most important, the description of the problem."
  },
  {
    "id": 189,
    "topic_id": 200,
    "title": "Know the common documentation in a network.",
    "description": "Incident documentation is created when a computer, network, or security incident has happened. You should be familiar with various elements of this documentation. The acceptable use policy (AUP) is a soft policy that protects an organization's resources from employee abuse. The password policy is also a soft policy that describes best practices for password creation and expectations of the end user."
  },
  {
    "id": 190,
    "topic_id": 200,
    "title": "Know the elements of change management documentation.",
    "description": "Change management is adopted by organizations to standardize the methods and procedures for any changes in the organization. Change management documentation is an integral part of this process. It is used to document a change so that it does not impede the organization's operations."
  },
  {
    "id": 191,
    "topic_id": 200,
    "title": "Understand how to prevent disasters and recover from data loss.",
    "description": "Data loss is the most common disaster an organization can suffer from on a day-to-day basis. You should understand how to prevent data loss with the implementation of data backups and other prevention methods. You should also understand how to protect an organization from power-related problems using uninterruptable power supplies and surge protection."
  },
  {
    "id": 192,
    "topic_id": 200,
    "title": "Know the various backup methods to prevent data loss.",
    "description": "There are three types of backups: full, incremental, and differential. Full backups copy all the data in a data set to media and reset the archive bit. An incremental backup copies only the data to media that has the archive bit set; it then resets all of the archive bits. A differential backup copies all the data in the data set to media that has the archive bit set, but it does not reset the archive bit."
  },
  {
    "id": 193,
    "topic_id": 200,
    "title": "Know proper communication techniques.",
    "description": "Listen to your customers. Let them tell you what they understand the problem to be, and then interpret the problem and see if you can get them to agree to what you are hearing them say. Treat your customers with respect, whether end users or colleagues, and take their issues and problems seriously. Use professionalism when working with customers, such as minimizing distractions, speaking in plain English, being punctual, and following up."
  }
];
